import script from "./WebAppChooseScore.vue?vue&type=script&setup=true&lang=js"
export * from "./WebAppChooseScore.vue?vue&type=script&setup=true&lang=js"

import "./WebAppChooseScore.vue?vue&type=style&index=0&id=07a5b91a&lang=scss&scoped=true"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a5b91a"]])

export default __exports__